var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('div',{staticClass:"container set-mt"},[_c('Alertmsg'),_c('router-view'),_c('button',{staticClass:"backtop",on:{"click":_vm.backTop}},[_c('i',{staticClass:"fas fa-arrow-up backtop-arrow"})])],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }